import { render, staticRenderFns } from "./ShipmentCommandQuery.vue?vue&type=template&id=6faa7844"
import script from "./ShipmentCommandQuery.vue?vue&type=script&lang=js"
export * from "./ShipmentCommandQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports